export default {
  screenId: 'gameScreen',
  screenWidth: 320,
  screenHeight: 200,
  magnification: 1,
}
